export default __webpack_public_path__ + "static/media/342.bbd43642.png";